<template>
  <v-card elevation="0" class="all-trade-tab terms-and-condition-tab rounded-0 mt-5" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-tabs v-model="model" background-color="transparent">
      <v-tab :href="`#tab-1`">
        T&C For Clients
      </v-tab>
      <v-tab :href="`#tab-2`">
        T&C For IB
      </v-tab>
      
      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <v-card class="mt-2" flat :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <clients-tab></clients-tab>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-2`">
          <v-card class="mt-2" flat :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <ib-tabs></ib-tabs>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>
<script>
import ClientsTab from './ClientsTab.vue';
import IbTabs from './IbTabs.vue';

export default {

  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },
  components: {
    ClientsTab,
    IbTabs
  },
};
</script>
